import translator from "@/translator";
import React, { useEffect, useState } from "react";
import { message, Form, Spin, Modal } from "antd";
import BackButton from "@/note_office/shared/BackButton";
import axios from "axios";
import NotificationForm from "./components/NotificationForm";
import Helper from "@/helper";

const t = translator("note_office.views.notifications.edit_view.");

const EditView = ({ notificationData }) => {
  const { notification, update_notification_url, notifications_index_url, preview_variables } =
    notificationData || {};
  const [body, setBody] = useState(notification?.body || "");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [form] = Form.useForm();
  const csrfToken = Helper.getCSRFToken();

  const [previewText, setPreviewText] = useState("");

  useEffect(() => {
    if (notificationData) {
      form.setFieldsValue({ body: notification.body });
      setBody(notification.body);
    }
    setLoading(false);
  }, [notificationData]);

  const replaceTemplateVariables = (text) => {
    if (!preview_variables) return text;

    return Object.entries(preview_variables).reduce((result, [variable, value]) => {
      const regex = new RegExp(`\\{${variable}\\}`, "gi");
      return result.replace(regex, value);
    }, text);
  };

  useEffect(() => {
    const filledText = replaceTemplateVariables(body);
    setPreviewText(filledText);
  }, [body, preview_variables]);

  const handleSubmit = async () => {
    setSaving(true);
    try {
      const response = await axios.patch(
        update_notification_url,
        {
          chategy_notification_setting: {
            body: body,
          },
        },
        {
          headers: {
            "X-CSRF-Token": csrfToken,
            "Content-Type": "application/json",
          },
        },
      );

      message.success(t("notification_updated"));
      window.location.href = response.data.redirect_path;
    } catch (error) {
      console.error(error);
      message.error(t("update_failed"));

      const errors = error.response.data.meta.errors;

      if (errors) {
        form.setFields(
          Object.entries(errors).map(([field, messages]) => ({
            name: field,
            errors: messages,
          })),
        );
      }
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    window.location.href = notifications_index_url;
  };

  const handleRestoreTemplate = () => {
    Modal.confirm({
      title: t("restore_template_confirm_title"),
      content: t("restore_template_confirm_text"),
      okText: t("buttons.confirm"),
      cancelText: t("buttons.cancel"),
      maskClosable: true,
      keyboard: true,
      onOk: () => {
        const defaultBody = notification?.default_body;

        setBody(defaultBody);
        form.setFieldsValue({ body: defaultBody });
        message.success(t("template_restored"));
      },
    });
  };

  return (
    <div className="wrapper wrapper__menu-layout overflow">
      {loading ? (
        <Spin size="large" className="loader" />
      ) : (
        <>
          <BackButton link={notifications_index_url} text={t("title")} />

          <NotificationForm
            form={form}
            notification={notification}
            loading={loading}
            saving={saving}
            onSubmit={handleSubmit}
            onCancel={handleCancel}
            body={body}
            setBody={setBody}
            previewText={previewText}
            onRestore={handleRestoreTemplate}
          />
        </>
      )}
    </div>
  );
};

export default EditView;
